import { StyledFooter, StyledImg, StyledParagraph } from './app-footer.style';

export const AppFooter = () => {
    return (
        <StyledFooter >
            <StyledImg
                src={`${process.env.PUBLIC_URL}/assets/icons/mogilev-library-icon.png`}
                alt="Изображение Могилевской областной бибилиотеки им. В.И. Ленина"
            />
            <StyledParagraph>
                Установа культуры &laquo;Магілёўская абласная бібліятэка ім. В. І.
                Леніна&raquo;
            </StyledParagraph>
        </StyledFooter>
    )
}